import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

//  CSS
import styles from "./../assets/css/Style.module.css";

export default function BackButton({ backPage }) {
    const [page, setPage] = useState("/");
    // let setPage = page;
    const history = useHistory();

    const closePage = () => {
        if (backPage !== undefined && backPage !== null) {
            history.push(page);
        }
    };

    useEffect(() => {
        setPage(backPage);
    }, [backPage]);

    return (
        <div onClick={() => closePage()}>
            <img className={styles.iconClose} src="/images/game/btn_back_circle.webp" alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." />
        </div>
    );
}